import { useState } from 'react';
import useApi from 'services/mavapi/useApi';
import {
  GeneralLookup,
  GeneralLookupWrapper,
  LookupService,
  UserGroupLookup,
} from 'services/openapi';

const useCommonLookUpDatas = () => {
  const [loading, setLoading] = useState(false);
  const [, setError] = useState<unknown | null>();
  const { error: apiError, handleRequest } = useApi();
  const [lookUps, setLookUps] = useState<Array<GeneralLookupWrapper>>([]);
  const [showLookUps, setShowLookUps] = useState<Array<GeneralLookup>>([]);
  const [teamLookUps, setTeamLookUps] = useState<Array<GeneralLookup>>([]);
  const [categoryLookUps, setCategoryLookUps] = useState<Array<GeneralLookup>>(
    [],
  );
  const [userTypeLookUps, setUserTypeLookUps] = useState<
    Array<UserGroupLookup>
  >([]);
  //API Services
  const {
    lookupGetAllLookups,
    lookupGetShowsLookupData,
    lookupGetTeamsLookupData,
    lookupGetCategoryLookupData,
    lookupGetUserTypeLookup,
  } = LookupService;
  //call lookups
  const getAllLookupData = (names?: string) => {
    setLoading(true);
    handleRequest(lookupGetAllLookups(names))
      .then(data => {
        if (data) setLookUps(data);
        setLoading(false);
      })

      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  const getUserTypeLookupData = () => {
    setLoading(true);
    handleRequest(lookupGetUserTypeLookup())
      .then(data => {
        if (data) setUserTypeLookUps(data);
        setLoading(false);
      })

      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  const getShowLookupWithSeasinId = (seasonId?: string) => {
    setLoading(true);
    handleRequest(lookupGetShowsLookupData(seasonId ?? ''))
      .then(data => {
        if (data) setShowLookUps(data);
        setLoading(false);
      })

      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  const getTeamLookupWithSeasonId = (seasonId?: string) => {
    setLoading(true);
    handleRequest(lookupGetTeamsLookupData(seasonId ?? ''))
      .then(data => {
        if (data) setTeamLookUps(data);
        setLoading(false);
      })

      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  const getCategoryLookupWithSeasonId = (seasonId?: string) => {
    setLoading(true);
    handleRequest(lookupGetCategoryLookupData(seasonId ?? ''))
      .then(data => {
        if (data) setCategoryLookUps(data);
        setLoading(false);
      })

      .catch(() => {
        setLoading(false);
        setError(apiError);
      });
  };
  return {
    loading,
    setLoading,
    lookUps,
    setLookUps,
    getAllLookupData,
    showLookUps,
    getShowLookupWithSeasinId,
    getTeamLookupWithSeasonId,
    teamLookUps,
    getCategoryLookupWithSeasonId,
    categoryLookUps,
    getUserTypeLookupData,
    userTypeLookUps,
  };
};

export default useCommonLookUpDatas;
